<template lang="pug">
product-carousel(v-model='products', :title='title', swiperid='iopioprer')
</template>

<script>
import axios from 'axios'
import ProductCarousel from './ProductCarousel.vue'
export default {
  components: { ProductCarousel },
  props: {
    title: {
      type: String,
      default: 'รุ่นอื่นที่น่าสนใจ',
    },

    cat: {
      type: Number,
      default: 37,
    },
  },
  data: () => ({
    products: [],
  }),

  mounted() {
    this.fetchProduct()
  },

  methods: {
    fetchProduct() {
      axios
        .get(`${UGO.api.url}v1/product/search`, {
          params: {
            cat_id: this.cat,
            per_page: 9,
            orderby: 'rand',
          },
        })
        .then(({ data }) => {
          this.products = data.data
        })
    },
  },
}
</script>